import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
/**
 * Get custom icon for special folders like inbox, drafts, sent, deleted, etc.
 * @param showNonSpecialFolderIcon Whether to show generic folder icon
 */
export default function getCustomIcon(folderId, showNonSpecialFolderIcon) {
    switch (folderId) {
        case folderNameToId('inbox'):
            return "Inbox" /* Inbox */;
        case folderNameToId('sentitems'):
            return "Send" /* Send */;
        case folderNameToId('drafts'):
            return "Edit" /* Edit */;
        case folderNameToId('deleteditems'):
            return "Delete" /* Delete */;
        case folderNameToId('archive'):
            return "Archive" /* Archive */;
        case folderNameToId('junkemail'):
            return "Blocked" /* Blocked */;
        case folderNameToId('scheduled'):
            return "Clock" /* Clock */;
        default:
            break;
    }
    if (showNonSpecialFolderIcon) {
        return "FabricFolder" /* FabricFolder */;
    }
    else {
        return null;
    }
}
//# sourceMappingURL=getCustomIcon.js.map